import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { FormikTouched, useFormikContext } from 'formik';

import { TEXT_FIELD_COLOR, TEXT_FIELD_VARIANT } from '../../enum/formProps';
import * as CommonSelectors from '../../../../shared/redux/commonSelectors';
import { ArticleValues } from '../../../../features/article/model/articleModel';
import Autocomplete from '../../elements/Autocomplete';

interface SelectProps {
  label: string;
  name: string;
  parent: (values: ArticleValues) => number | undefined;
  disabled: (name: string, values: ArticleValues, touched: FormikTouched<ArticleValues>) => boolean;
  readOnly?: boolean;
  clearFieldsValue?: (
    values: ArticleValues,
    touched: FormikTouched<ArticleValues>,
    setFieldValue: (field: string, value: any, shouldValidate?: boolean) => void,
    setFieldTouched: (field: string, isTouched?: boolean, shouldValidate?: boolean) => void,
  ) => void;
  clearFieldsDeps?: (values: ArticleValues) => string;
  color?: TEXT_FIELD_COLOR;
  variant?: TEXT_FIELD_VARIANT;
  categoryId?: number;
}

const CategorySelect: React.FC<SelectProps> = (props) => {
  const { values, touched, setFieldValue, setFieldTouched } = useFormikContext<ArticleValues>();
  const categoriesOptionList = useSelector(
    CommonSelectors.getCategoriesOptionListByParentId(props.parent(values), props.categoryId),
  );
  const clearFieldsDeps = props.clearFieldsDeps ? props.clearFieldsDeps(values) : null;

  useEffect(() => {
    setFieldTouched(props.name);

    props.clearFieldsValue && props.clearFieldsValue(values, touched, setFieldValue, setFieldTouched);
  }, [clearFieldsDeps]);

  return (
    <Autocomplete
      label={props.label}
      name={props.name}
      options={categoriesOptionList}
      readOnly={props.readOnly}
      disabled={props.disabled(props.name, values, touched)}
    />
  );
};

export default CategorySelect;
